import { render, staticRenderFns } from "./AdsStandard.vue?vue&type=template&id=3051a967&scoped=true"
import script from "./AdsStandard.vue?vue&type=script&lang=js"
export * from "./AdsStandard.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051a967",
  null
  
)

export default component.exports